// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

.ec-return-reason-select-div ion-select {
  width: 100%;
  border: 1px;
  border-color: var(--ion-color-primary-tint);
  border-style: solid;
  border-radius: 40px;
  height: calc(32 * var(--width-ratio));
  text-align: center;
}
.ec-return-reason-select-div .myselect {
  margin-left: calc(16 * var(--width-ratio));
  margin-top: calc(8 * var(--width-ratio));
}
.ec-return-reason-select-div .myselect ::part(text) {
  color: var(--ion-color-dark-tint);
}

.ec-return-reason-textarea ion-textarea {
  border-radius: 10px;
  --background: rgba(var(--ion-color-light-tint-rgb), 0.5);
  --border-radius: 10px;
  --padding-start: calc(10 * var(--width-ratio));
  --padding-end: calc(10 * var(--width-ratio));
}

.footer {
  box-shadow: unset;
  padding-top: calc(6 * var(--width-ratio));
  padding-bottom: calc(6 * var(--width-ratio));
}
.footer .mybutton {
  --background: var(--ion-color-danger-tint);
  width: calc(328 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  margin: auto;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/ec-return-reason-modal/ec-return-reason-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAGE;EACE,WAAA;EAEA,WAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;AADJ;AAIE;EACE,0CAAA;EACA,wCAAA;AAFJ;AAMI;EACE,iCAAA;AAJN;;AAUE;EACE,mBAAA;EACA,wDAAA;EAEA,qBAAA;EACA,8CAAA;EACA,4CAAA;AARJ;;AAYA;EACE,iBAAA;EACA,yCAAA;EACA,4CAAA;AATF;AAWE;EACE,0CAAA;EACA,qCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AATJ","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n.ec-return-reason-select-div {\n  ion-select {\n    width: 100%;\n\n    border: 1px;\n    border-color: var(--ion-color-primary-tint);\n    border-style: solid;\n    border-radius: 40px;\n    height: calc(32 * var(--width-ratio));\n    text-align: center;\n  }\n\n  .myselect {\n    margin-left: calc(16 * var(--width-ratio));\n    margin-top: calc(8 * var(--width-ratio));\n    // background: rgba(162, 146, 193, 0.1);\n    // border-radius: 10px;\n\n    ::part(text) {\n      color: var(--ion-color-dark-tint);\n    }\n  }\n}\n\n.ec-return-reason-textarea {\n  ion-textarea {\n    border-radius: 10px;\n    --background: rgba(var(--ion-color-light-tint-rgb), 0.5);\n    //--background: var(--ion-color-light-tint);\n    --border-radius: 10px;\n    --padding-start: calc(10 * var(--width-ratio));\n    --padding-end: calc(10 * var(--width-ratio));\n  }\n}\n\n.footer {\n  box-shadow: unset;\n  padding-top: calc(6 * var(--width-ratio));\n  padding-bottom: calc(6 * var(--width-ratio));\n\n  .mybutton {\n    --background: var(--ion-color-danger-tint);\n    width: calc(328 * var(--width-ratio));\n    height: calc(42 * var(--width-ratio));\n    margin: auto;\n    --border-radius: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
